import React from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, useThemeContext } from "./contexts/ThemeContext";
import { ConfigProvider } from "./contexts/ConfigContext";
import EditorPage from "./pages/EditorPage";
import PostPage from "./pages/PostPage";
import "./styles/theme.css";
import "./styles/App.css";

function AppRoutes() {
  const { theme } = useThemeContext();

  return (
    <div className="App" data-theme={theme}>
      <Routes>
        <Route path="/" element={<EditorPage />} />
        <Route path="/post/:slug" element={<PostPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ConfigProvider>
        <AppRoutes />
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;
